// Slow-drifting, blurred planet-colored orbs rendered as a fixed backdrop on the
// lore pages. Pure CSS (no canvas), cheap, respects reduced-motion. Colored to
// match the system's bodies so the lorebook feels like a glimpse of the orrery.

interface OrbDef {
  color: string
  size: number
  top: string
  left: string
  dur: number // seconds per drift cycle
  delay: number // negative = starts mid-cycle so orbs aren't synchronized
}

// Kept to a few, pushed to the screen edges so the reading column in the
// middle stays calm. They bleed in as soft glow rather than sitting on top of
// the text.
const ORBS: OrbDef[] = [
  { color: '#ffb24a', size: 460, top: '-16%', left: '-8%', dur: 54, delay: 0 }, // Pyrithos, top-left corner
  { color: '#b06bff', size: 420, top: '58%', left: '-10%', dur: 62, delay: -20 }, // Thelxis, left edge
  { color: '#7cf6ff', size: 380, top: '28%', left: '90%', dur: 58, delay: -34 }, // signal, right edge
]

/** Fixed full-viewport ambient glow layer. Render once near the app root. */
export function BackdropOrbs() {
  return (
    <div className="lore-backdrop" aria-hidden="true">
      {ORBS.map((o, i) => (
        <span
          key={i}
          className="lore-orb"
          style={{
            width: o.size,
            height: o.size,
            top: o.top,
            left: o.left,
            background: `radial-gradient(circle at 50% 50%, ${o.color} 0%, transparent 70%)`,
            animationDuration: `${o.dur}s`,
            animationDelay: `${o.delay}s`,
          }}
        />
      ))}
    </div>
  )
}
